import React, {useState} from 'react'
import '../../App.css'
import Container from 'react-bootstrap/Container'
import Row from 'react-bootstrap/Row'
import Col from 'react-bootstrap/Col'
import Form from 'react-bootstrap/Form'
import Button from 'react-bootstrap/Button'
import DaumPostcode from 'react-daum-postcode'
import axios from "axios";
import img from '../../images/find.png'

function ConsultForm () {
  const [validated, setValidated] = useState(false);

  const [mailSent, setmailSent] = useState(false);
  const [error, setError] = useState(null);


  const [isOpenPost, setIsOpenPost] = useState(false);
  const onChangeOpenPost = () => {
    setIsOpenPost(!isOpenPost);
  };

  const onCompletePost = (data) => {
    let fullAddress = data.address;
    let extraAddr = '';

    if (data.addressType === 'R') {
      if (data.bname !== '') {
        extraAddr += data.bname;
      }
      if (data.buildingName !== '') {
        extraAddr += extraAddr !== "" ? `, ${data.buildingName}` : data.buildingName;
      }
      fullAddress += extraAddr !== "" ? ` (${extraAddr})` : '';
    }

    setCode(data.zonecode);
    setAddress(fullAddress);
    setIsOpenPost(false);
  };

  const postCodeStyle = {
    display: "block",
    position: "absolute",
    width: "500px",
    height: "375px",
    padding: "7px",
  };

  // var form = document.querySelector('Form');
  // var data = new FormData(form);

  const [postCode, setCode] = useState(''); // 주소
  const [address, setAddress] = useState('');
  const [addressDetail, setAddressDetail] = useState('');
  const [name, setName] = useState("");
  const [number1, setNumber1] = useState("");
  const [number2, setNumber2] = useState("");
  const [email, setEmail] = useState("");
  const [check, setCheck] = useState(Boolean);

  const [enemail, setEnEmail] = useState("");


  const url = "https://shareplug.co.kr/_web_api/sendmail.php";
  // const url = "/home_php/sendmail.php";

  const state = {name, number1, address, postCode, addressDetail, number2, email, enemail};
  // const formData = new FormData(state);
  // const object = Object.fromEntries(formData.entries())
  const handleSend = (event) =>{
    const form = event.currentTarget;
    if(form.checkValidity() === false) {
      event.preventDefault();
      event.stopPropagation();
      // console.log(data)
      setValidated(true);
    }
    else if(form.checkValidity() === true){
      setValidated(true);
      event.preventDefault();
      axios.post(url, JSON.stringify(state)).then(result => {
        console.log(result);
        if(result.data.sent) {
          setmailSent(result.data.sent)
          setError(false)
        }else{
          setError(true)
        }
      })
      .catch(error => setError(error.message));
      console.log(state)
      // console.log(data)
    };
  }
  const handleSubmit = (event) =>{
    const form = event.currentTarget;
    if(form.checkValidity() === false) {
      event.preventDefault();
      event.stopPropagation();
      // console.log(data)
    }
    else if(form.checkValidity() === true){
      event.preventDefault();
      axios.post(url, JSON.stringify(state)).then(result => {
        console.log(result);
        if(result.data.sent) {
          alert("Email Sent Successfully")
        }else{
          alert("Email Sent Successfully")
        }
      })
      .catch(error => setError(error.message));
      console.log(enemail)
    }
  }
  
  return (
    <div>
      <div className='consultForm'>
      {localStorage.getItem('i18nextLng') ==="en" ? 
        <Container>
          <Form style={{textAlign:"center"}} onSubmit={handleSubmit}>
            <Form.Group className="mb-3" style={{display: "grid"}} controlId="formBasicEmail">
              <Form.Label>Sign Up for News</Form.Label>
              <Form.Control required onChange={e => setEnEmail(e.target.value)} type="email" placeholder="Enter email" />
              <Form.Text className="text-muted">
                We'll never share your email with anyone else.
              </Form.Text>
            </Form.Group>  
            <Button variant="primary" type="submit" id="submit" style={{width: "20%"}}>
              Submit
            </Button>
          </Form>
        </Container> 
      : localStorage.getItem("i18nextLng") === "ko"?
        <Container>
          <Row>
            <Col>
              <h1>상담 신청</h1>
              <p>상담 신청을 남겨주시면 24시간 이내 담당자가 연락을 드립니다.</p>
            </Col>
            <Form noValidate validated={validated} onSubmit={handleSend}>
                <Row>
                  <Col controlid="validationCustom01">
                    <Form.Label  className="col-form-label">신청인</Form.Label>
                    <Form.Control onChange={e => setName(e.target.value)} required type='text' name='name' id="name" placeholder="성함을 입력해주세요" className='form-control' />
                    <Form.Control.Feedback type="invalid">성함을 정확하게 입력해주세요</Form.Control.Feedback>
                    
                  </Col>
                  <Col controlid="validationCustom02">
                    <Form.Label  className="col-form-label">연락처</Form.Label>
                    <Form.Control onChange={e => setNumber1(e.target.value)} required type="number" name="number1" id="number1" placeholder="- 를 제외한 숫자만 입력해주세요" className='form-control' />
                    <Form.Control.Feedback type="invalid">전화번호를 입력해주세요</Form.Control.Feedback>
                    
                  </Col>
                </Row>
                <Row>
                  <Col controlid="validationCustom03">
                    <Form.Label  className="col-form-label">설치 장소</Form.Label>
                    <Form.Control onChange={e => setAddress(e.target.value)} required className='address' name="address" id="address" as='textarea' rows='1' placeholder="주소" disabled value={address + postCode} />
                    <button type="button" className='button' onClick={onChangeOpenPost}><img src={img} alt='' className='consultImg' /></button>
                    {isOpenPost ? (
                      <DaumPostcode style={postCodeStyle} autoClose onComplete={onCompletePost } />
                    ) : null}
                    <Form.Control.Feedback type="invalid">
                      주소를 입력해주세요
                    </Form.Control.Feedback> 
                    
                    <Form.Control name="addressDetail" id="addressDetail" onChange={e => setAddressDetail(e.target.value)} required placeholder="상세 주소" />
                    <Form.Control.Feedback type="invalid">
                      주소를 입력해주세요
                    </Form.Control.Feedback>
                  </Col>
                  <Col>
                    <Form.Label className="col-form-label">설치 예상 대수</Form.Label>
                    <Form.Control onChange={e => setNumber2(e.target.value)} required type="number" name="number2" id='number2' placeholder="수량을 입력해주세요" />
                    <Form.Control.Feedback type="invalid">수량을 입력해주세요</Form.Control.Feedback>
                    <Form.Label className="col-form-label">이메일</Form.Label>
                    <Form.Control onChange={e => setEmail(e.target.value)} required type="email" placeholder="이메일을 입력해주세요" />
                    <Form.Control.Feedback type="invalid">이메일을 입력해주세요</Form.Control.Feedback>

                  </Col>
                </Row>
              <Row>
                <Form.Group className="mb-3">
                  <Form.Check
                    required
                    label="개인정보 취급 방침 동의 "
                    feedback="동의해주세요"
                    feedbackType="invalid"
                    onChange={e => setCheck(e.target.value)}
                  /><span>|</span><a href='/'>  내용보기</a>
                </Form.Group>
              </Row>
              <Button type="submit" className='btn'>
                상담 신청
              </Button>
              <div> 
                {mailSent && <div className="sucsess"> Success</div>}
                {error && <div className="error" >정상적으로 상담 신청이 등록되었습니다.</div>}
              </div>
            </Form>
          </Row>
        </Container> : null}
      </div>
    </div>
  )
}

export default ConsultForm
